import { useTranslation } from 'react-i18next'
import { ButtonLink } from '../Button/ButtonLink'
import { Icon } from '../Icon/Icon'
import { cx } from '../utils/cx'
import type { ContactBlockProps } from './types'
import './ContactBlock.css'

/** Bloque de contacto (DESIGN.md §4): WhatsApp primario, email y teléfono secundarios, emergencia siempre visible. */
export function ContactBlock({
  whatsappHref,
  whatsappNote,
  emailHref,
  phoneHref,
  emergencyPhone,
  emergencyLabel,
  className,
}: ContactBlockProps) {
  const { t } = useTranslation()
  return (
    <div className={cx('hp-contact', className)}>
      {whatsappHref && (
        <ButtonLink
          variant="primary"
          icon="message-circle"
          href={whatsappHref}
          target="_blank"
          rel="noreferrer"
        >
          {t('v2.ds.contact.whatsapp')}
        </ButtonLink>
      )}
      {whatsappNote && <p className="hp-contact__note">{whatsappNote}</p>}
      {(emailHref || phoneHref) && (
        <div className="hp-contact__secondary">
          {emailHref && (
            <ButtonLink variant="secondary" icon="mail" href={emailHref}>
              {t('v2.ds.contact.email')}
            </ButtonLink>
          )}
          {phoneHref && (
            <ButtonLink variant="secondary" icon="phone" href={phoneHref}>
              {t('v2.ds.contact.llamar')}
            </ButtonLink>
          )}
        </div>
      )}
      {emergencyPhone && (
        <a href={`tel:${emergencyPhone.replace(/\s/g, '')}`} className="hp-contact__emergency">
          <Icon name="life-buoy" size={22} className="hp-contact__emergency-icon" />
          <span>
            {emergencyLabel ?? t('v2.ds.contact.emergencias')}{' '}
            <span className="tnum">{emergencyPhone}</span>
          </span>
        </a>
      )}
    </div>
  )
}
